import 'date-input-polyfill';
/* App sass style */
import './platform/static/style/app.scss';

import PiivoPosterEngine from 'piivo-poster-engine/src/lib';
/* PiivoUI import interface components */
import PiivoUI from 'piivo-ui/src';
import Vue from 'vue';
import VueCookie from 'vue-cookie';
import VueResource from 'vue-resource';
import VueRouter from 'vue-router';
import Vuelidate from 'vuelidate';

import App from './App.vue';
import Auth from './core/authentication';
import { permission } from './core/directives/permission';
import extensionPoints from './core/extensionPoints';
import * as filters from './core/filters';
import helpers from './core/helpers';
import HelperManager from './core/helpers/plugin';
import i18n from './core/i18n';
import router from './core/router';
import services from './core/services/';
/* Import custom plugins */
import store from './core/store';
import Admin from './modules/admin';
import Common from './modules/common';
import { puiProvide } from './modules/common/piivo-ui';
import Dam from './modules/dam';
import Poster from './modules/poster';
import Platform from './platform';

/* Install plugins */
Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(Vuelidate);
Vue.use(VueCookie);
Vue.use(HelperManager);

/* Install filters */
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;

/* Custom directives */
Vue.directive('permission', permission);

/* Auth plugin */
Vue.use(Auth);

/* Install custom plugins and modules */
Vue.use(PiivoUI);
Vue.use(PiivoPosterEngine);
Vue.use(Platform, { store, router, services, helpers, extensionPoints });
Vue.use(Common, { store, router, services, helpers, extensionPoints });
Vue.use(Admin, { store, router, services, helpers, extensionPoints });
Vue.use(Poster, { store, router, services, helpers, extensionPoints });
Vue.use(Dam, { store, router, services, helpers, extensionPoints });

new Vue({
  // eslint-disable-line
  el: '#evo-app',
  // Attach the Vue instance to the window,
  // so it's available globally.
  created: function() {
    window.Vue = Vue;
  },
  render: h => h(App),
  router,
  store,
  i18n,
  services,
  helpers,
  extensionPoints,
  provide() {
    return {
      ...puiProvide,
    };
  },
}).$mount('#evo-app');
